/*
    Обрезание длинного текста троеточием
*/

export function ellipsis() {
    const $ell = App.H.find('.js-ellipsis');

    if ($ell.length) {
        $ell.trigger('destroy.dot');
        $ell.dotdotdot();
    }
}

App.W.on('load resized', ellipsis);




// WEBPACK FOOTER //
// ./_src/js/modules/Ellipsis.js